import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { XCircle, CheckCircle2, Lock, Zap, ShieldCheck } from 'lucide-react';
export function ClosingSection() {
  return <section className="py-24 px-4 bg-navy-800 border-t border-navy-700" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-17">
            Tienes dos caminos hoy:
          </h2>
          <p className="text-xl text-gray-400" data-id="element-18">
            La decisión que tomes ahora definirá tus próximos 5 años.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900/50 p-8 rounded-2xl border border-red-900/30" data-id="element-20">
            <div className="flex items-center gap-3 mb-6" data-id="element-21">
              <XCircle className="text-red-500 w-8 h-8" data-id="element-22" />
              <h3 className="text-2xl font-bold text-white" data-id="element-23">Camino A</h3>
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-24">
              No hacer nada. Seguir pagando el mínimo, seguir recibiendo
              llamados a toda hora y ver cómo tu deuda crece mientras el banco
              se ríe de ti. En 6 meses estarás peor que hoy, con más estrés y
              menos opciones.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900 p-8 rounded-2xl border border-gold-500/50 shadow-[0_0_30px_rgba(201,168,76,0.1)]" data-id="element-25">
            <div className="flex items-center gap-3 mb-6" data-id="element-26">
              <CheckCircle2 className="text-gold-500 w-8 h-8" data-id="element-27" />
              <h3 className="text-2xl font-bold text-white" data-id="element-28">Camino B</h3>
            </div>
            <p className="text-gray-300 leading-relaxed" data-id="element-29">
              Tomar acción por el precio de una salida al cine. Aplicar el
              protocolo, blindar tu sueldo hoy mismo y empezar a ver cómo tus
              deudas desaparecen legalmente. Recuperar tu paz mental y tu
              libertad.
            </p>
          </motion.div>
        </div>

        <div className="text-center space-y-8" data-id="element-30">
          <h3 className="text-3xl font-serif text-white italic" data-id="element-31">
            ¿Cuál vas a elegir?
          </h3>
          <CtaButton data-id="element-32" />
          <div className="flex justify-center gap-8 text-sm text-gray-500" data-id="element-33">
            <span className="flex items-center gap-1.5" data-id="element-34"><Lock size={14} data-id="element-35" /> Pago Seguro</span>
            <span className="flex items-center gap-1.5" data-id="element-36"><Zap size={14} data-id="element-37" /> Acceso Inmediato</span>
            <span className="flex items-center gap-1.5" data-id="element-38"><ShieldCheck size={14} data-id="element-39" /> Garantía 7 Días</span>
          </div>
        </div>
      </div>
    </section>;
}